import React, {useState} from 'react';
import Element from './Element';
import { useDrop } from 'react-dnd';
import "./dnd.scss";


const ElementList = [
    {
        id: 1,
        url: "Student Name",
    },
    {
        id: 2,
        url: "https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/c96fffbf-a334-4431-9e97-8d91347a6efd/ddnwdet-869fdd04-0a7e-4e7f-8acf-30e6a4404d9d.jpg/v1/fill/w_622,h_350,q_70,strp/frostblade_irelia_vs_katarina_by_dominaart_ddnwdet-350t.jpg?token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9OTAwIiwicGF0aCI6IlwvZlwvYzk2ZmZmYmYtYTMzNC00NDMxLTllOTctOGQ5MTM0N2E2ZWZkXC9kZG53ZGV0LTg2OWZkZDA0LTBhN2UtNGU3Zi04YWNmLTMwZTZhNDQwNGQ5ZC5qcGciLCJ3aWR0aCI6Ijw9MTYwMCJ9XV0sImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS5vcGVyYXRpb25zIl19.pytJgMfRA5pFhOYC4Xc4Ljy0BSc3mTwfus5BNQmQeqQ",
    },
    {
        id: 3,
        url: "https://external-preview.redd.it/8Bi-4wkuZYRAeXV0Y61YhCWrFY8TJmp7gi4r7nsP--I.jpg?auto=webp&s=24c43941bf561c60cb4593cc2301224d9825cbd8",
    },
];

function DragDrop() {
    const [board, setBoard] = useState([ ]);

    const [{isOver}, drop] = useDrop(({
        accept: "element",
        drop: (item) => addElementToBoard(item.id),
        collect: (monitor) => ({
            isOver: !!monitor.isOver(),
        }),
    }));

    const ResizableBox = require('react-resizable').ResizableBox;

    const addElementToBoard = (id) => {
        const elementList = ElementList.filter((element) => id === element.id);
        setBoard((board) => [...board, elementList[0]]);
    };

    return(
        <>
            <div className='Element'> {ElementList.map((element)=> {
                return <Element key={element.id} url={element.url} id={element.id} />;
            })}{" "}
            </div>

        <div className='Board' ref={drop}>
            {board.map((element) => {
                return <Element key={element.id} url={element.url} id={element.id} />
            })}
        </div>
        </>
    );
}

export default DragDrop;
